import { api } from '../api';
import { API_ENDPOINTS } from '../../utils/constants';

export const subscriptionService = {
  /**
   * Get current subscription status for the logged-in admin
   */
  getStatus: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.ADMIN.SUBSCRIPTION);
      return { success: response.status, data: response.data };
    } catch (error) {
      if (error.isSubscriptionExpired) {
        return { success: true, data: { has_subscription: false, subscription: null } };
      }
      return { success: false, message: error.message || 'Failed to fetch subscription status' };
    }
  },

  /**
   * Quick subscription check (for guards/middleware)
   */
  check: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.ADMIN.SUBSCRIPTION_CHECK);
      return { success: response.status, data: response.data };
    } catch (error) {
      if (error.isSubscriptionExpired) {
        return { success: true, data: { has_access: false, subscription: null } };
      }
      return { success: false, message: error.message || 'Failed to check subscription' };
    }
  },

  /**
   * Initiate renewal - creates a pending payment
   */
  renew: async (data) => {
    try {
      const response = await api.post(API_ENDPOINTS.ADMIN.SUBSCRIPTION_RENEW, data);
      return { success: response.status, data: response.data, message: response.message };
    } catch (error) {
      return { success: false, message: error.message || 'Failed to initiate renewal' };
    }
  },

  /**
   * Confirm payment after gateway callback
   */
  confirmPayment: async (data) => {
    try {
      const response = await api.post(API_ENDPOINTS.ADMIN.SUBSCRIPTION_CONFIRM_PAYMENT, data);
      return { success: response.status, data: response.data, message: response.message };
    } catch (error) {
      return { success: false, message: error.message || 'Failed to confirm payment' };
    }
  },

  /**
   * Get payment history
   */
  getPayments: async (params = {}) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const endpoint = `${API_ENDPOINTS.ADMIN.SUBSCRIPTION_PAYMENTS}${queryString ? `?${queryString}` : ''}`;
      const response = await api.get(endpoint);
      return { success: response.status, data: response.data, meta: response.meta };
    } catch (error) {
      return { success: false, message: error.message || 'Failed to fetch payment history' };
    }
  },
};
